function syncGalleryArrows(slideshow, index = 0) {
  const arrows = slideshow.querySelector('.reference-mobile-gallery-arrows');
  if (!arrows) return;

  const previous = arrows.querySelector('.slideshow-control--previous');
  const next = arrows.querySelector('.slideshow-control--next');
  const slideCount = slideshow.querySelectorAll('slideshow-slide:not([hidden])').length;

  if (previous instanceof HTMLButtonElement) {
    const unavailable = index <= 0;
    previous.hidden = unavailable;
    previous.disabled = unavailable;
  }

  if (next instanceof HTMLButtonElement) {
    const unavailable = index >= slideCount - 1;
    next.hidden = unavailable;
    next.disabled = unavailable;
  }
}

function initializeMobileGalleryControls(root = document) {
  root.querySelectorAll('.product-information--reference-layout slideshow-component').forEach((slideshow) => {
    if (!(slideshow instanceof HTMLElement) || slideshow.dataset.mobileArrowSync === 'true') return;

    slideshow.dataset.mobileArrowSync = 'true';
    syncGalleryArrows(slideshow, 0);
    slideshow.addEventListener('slideshow:select', (event) => {
      syncGalleryArrows(slideshow, Number(event.detail?.index || 0));
    });
  });
}

initializeMobileGalleryControls();
document.addEventListener('shopify:section:load', (event) => initializeMobileGalleryControls(event.target));
